// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xPDp6_U97GiWxdlfA2mR > small {
  display: block;
  font-size: 0.9em;
  margin-top: 2em;
  opacity: 0.6;
}
.form {
  width: 28vw;
}
.themes {
  display: flex;
  gap: 1em;
}
.themes > span {
  flex: 2.4em 0 0;
  height: 2.4em;
  border: var(--dry-border);
  border-width: 2px;
  border-radius: 50%;
  background-color: var(--primary);
  margin: 0.3em;
  cursor: pointer;
}
.themes > span[data-active="true"] {
  outline: 0.3em solid var(--primary);
  cursor: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xPDp6_U97GiWxdlfA2mR`,
	"form": `form`,
	"themes": `themes`
};
export default ___CSS_LOADER_EXPORT___;
